// Libraries
import React, {useState, useEffect, useContext} from "react"
import { connect } from "react-redux"
import {VentureFacilitiesContainer} from "./styled";
import {updateVentureFacilities, fetchVentureFacilitiesOptions} from "../../../../../store/modules/ventures/actions";
import StyledCheckboxList from "../../../../../components/StyledCheckboxList/StyledCheckboxList";
import StyledButton from "../../../../../components/StyledButton/StyledButton";
import {Container} from "../../../../../structureComponents";
import {setSnackbarState, setUserHasChanges} from "../../../../../store/modules/global/actions";
import {ADMIN_USER_ROLE} from "../../../../../utils/constants";
import {AuthContext} from "../../../../../Auth";


function VentureFacilities({
   dispatchUpdateVentureFacilities,
   currentVenture,
   ventureFacilitiesOptions,
   dispatchFetchVentureFacilitiesOptions,
    onUserChanges = () => ({}),
    dispatchSnackbar,
    dispatchSetUserHasChanges
}) {
    const { currentUser } = useContext(AuthContext)

    // State
    const [loading, setLoading] = useState(false)
    const [facilitiesIds, setFacilitiesIds] = useState([])
    const [userHasChanges, setUserHasChanges] = useState(false)


    // Mounted
    useEffect(() => {
        dispatchFetchVentureFacilitiesOptions()
        onUserChanges(false)
    }, [])

    // Watchers
    useEffect(() => {
        if (currentVenture && currentVenture.facilitiesIds) {
            setFacilitiesIds(currentVenture.facilitiesIds.map(id => parseInt(id)))
        }
    }, [currentVenture])

    useEffect(() => {
        if (userHasChanges) {
            onUserChanges(userHasChanges)
        } else {
            onUserChanges(false)
        }
    }, [userHasChanges])

    // Methods
    const handleVentureFacilitiesOnChange = (ventureFacilitiesIds) => {
        setFacilitiesIds(ventureFacilitiesIds.map(id => parseInt(id)))

        if (ventureFacilitiesIds.length !== facilitiesIds.length) {
            setUserHasChanges(true)
            dispatchSetUserHasChanges(true)
        } else {
            setUserHasChanges(false)
            dispatchSetUserHasChanges(false)
        }
    }

    const handleUpdateVentureFacilities = async () => {
        try {
            setLoading(true)

            const corporationId = currentVenture.corporationId
            const ventureId = currentVenture.id
            const active = currentVenture.active

            await dispatchUpdateVentureFacilities({ corporationId, ventureId, active }, { facilitiesIds })
            setUserHasChanges(false)
            dispatchSetUserHasChanges(false)
            dispatchSnackbar({
                type: "success",
                active: true,
                message: "Empreendimento atualizado com sucesso"
            })
        } catch (error) {
            console.error(error)
            dispatchSnackbar({
                type: "error",
                active: true,
                message: "Infelizmente ocorreu um erro"
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <VentureFacilitiesContainer>
            <Container viewOnly={currentUser?.role !== ADMIN_USER_ROLE} fluid maxWidth="80em">
                <StyledCheckboxList
                    items={ventureFacilitiesOptions}
                    groupedBy="category"
                    checkedItems={currentVenture?.facilitiesIds}
                    onChange={handleVentureFacilitiesOnChange} />
                {currentUser?.role === ADMIN_USER_ROLE && (
                    <Container flex alignCenter fluid justifyEnd mt="40px">
                        <Container disabled={!userHasChanges} flex alignCenter justifyEnd ml="10px">
                            <StyledButton
                                disabled={!userHasChanges}
                                loading={loading}
                                kind="primary"
                                onClick={handleUpdateVentureFacilities}>
                                Salvar
                            </StyledButton>
                        </Container>
                    </Container>
                )}
            </Container>
        </VentureFacilitiesContainer>
    )
}

const mapStateToProps = (state) => ({
    currentVenture: state.ventures.currentVenture,
    ventureFacilitiesOptions: state.ventures.ventureFacilitiesOptions
})

const mapDispatchToProps = (dispatch) => ({
    async dispatchUpdateVentureFacilities({ corporationId, ventureId, active }, { facilitiesIds }) {
        await dispatch(updateVentureFacilities({ corporationId, ventureId, active }, { facilitiesIds }))
    },

    async dispatchFetchVentureFacilitiesOptions() {
        await dispatch(fetchVentureFacilitiesOptions())
    },

    dispatchSnackbar({ message, type, active }) {
        dispatch(setSnackbarState({ message, type, active }))
    },

    dispatchSetUserHasChanges(userHasChanges) {
        dispatch(setUserHasChanges(userHasChanges))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(VentureFacilities)
